import { IHocKyDangKy } from "../../model/respone/lop-tin-chi/IHocKyDangKy";
import { IQuyDinhDangKyVm } from "../../model/respone/lop-tin-chi/IQuyDinhDangKyVm";
import { apiClient } from "../apiClient";
export const KY_DANG_KY_API = "ky-dang-ky";
export const hocKyDangKyApi = {
  SelectAll: () => apiClient.get(`${KY_DANG_KY_API}`),
  MaxDot: (nam_hoc: string, hoc_ky: number, id_he: number) =>
    apiClient.get(`${KY_DANG_KY_API}/max-dot?nam_hoc=${encodeURIComponent(nam_hoc)}&hoc_ky=${hoc_ky}&id_he=${id_he}`),
  Insert: (payload: IHocKyDangKy) => apiClient.post(`${KY_DANG_KY_API}`, payload),
  Update: (payload: IHocKyDangKy) => apiClient.put(`${KY_DANG_KY_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${KY_DANG_KY_API}/${id}`),
  SelectQuyDinh: (id: number) => apiClient.get(`${KY_DANG_KY_API}/${id}/quy-dinh`),
  SubmitQuyDinh: (data: IQuyDinhDangKyVm) => apiClient.put(`${KY_DANG_KY_API}/quy-dinh`, data),
};
